import styled from 'styled-components'

import { TextStyled } from './TextStyled'

export const TextLabelStyled = styled((props) => <TextStyled {...props} />)`
  font-size: ${(props) =>
    props.theme.typography.pxToRem(props.theme.fontSizes.label)};
  line-height: 2;
  font-weight: ${(props) => props.theme.fontWeights.semibold};
`
